<template>
  <BaseModal :is-open="show" :backdrop-dismiss="false">
    <div class="flex flex-col items-center p-6">
      <img src="../../public/assets/icons/version-update-icon.svg" />
      <h2 class="mt-6 font-aktiv-grotesk-medium text-2xl">New Update Available</h2>
      <p class="mt-6 font-aktiv-grotesk-regular text-base">
        Download the latest version now to<br />unlock all features of Generations!
      </p>
      <BaseButton
        :solid-classes="`mt-6 rounded-full items-center py-4 px-5 bg-[#00A9E0] hover:opacity-75`"
        :fullWidth="true"
        :round="100"
        @click="handleUpdate"
      >
        <p class="text-white text-center font-aktiv-grotesk-medium text-xl">Update now</p>
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script>
import { openStore } from '../utils/versionCheck';
import BaseModal from './common/BaseModal.vue';
import BaseButton from './common/BaseButton.vue';

export default {
  name: 'UpdateModal',
  components: { BaseModal, BaseButton },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleUpdate() {
      openStore();
    },
  },
};
</script>
